import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as FeedItemActions from 'web-app/react/entities/feed/items/actions';
import {ObservationVariant} from 'web-app/react/entities/observations/constants';

import * as Actions from './actions';

const PostObservationModal = Record({
    isVisible: false,
    passive: false,
    observation: undefined,
    observationVariant: ObservationVariant.REGULAR_OBSERVATION,
    onSuccess: undefined,
});

export default handleActions(
    {
        [Actions.edit.type]: (state, {payload}) => {
            return new PostObservationModal({
                isVisible: true,
                passive: payload.passive,
                observation: payload.observation,
                observationVariant: payload.observation.variant,
                onSuccess: payload.onSuccess,
            });
        },
        [Actions.hide.type]: () => new PostObservationModal(),
        [FeedItemActions.updateItemSuccess.type]: () => new PostObservationModal(),
    },
    new PostObservationModal(),
);
